import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { BulkPayService } from '../bulk-pay.service';
import * as bulkPayActions from './bulk-pay.actions'

@Injectable({
    providedIn: 'root'
})

export class BulkPayEffects {
    constructor(
        private actions$: Actions,
        private bulkPayService: BulkPayService,
        private toastr: ToastrService,
        private miscService: MiscService,
    ) {}

    fetchCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(bulkPayActions.fetchCountries),
      exhaustMap((action) =>
        this.miscService
          .getCountries()
          .pipe(
            exhaustMap((response: any) => [
                bulkPayActions.fetchCountriesSuccess({ countries: response.data }),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(bulkPayActions.fetchCountriesFailed())
            }
            )
          )
      )
    )
  );

fetchRecipientCategories$ = createEffect(() =>
  this.actions$.pipe(
    ofType(bulkPayActions.fetchRecipientCategories),
    exhaustMap(({ page, limit, search, startDate, endDate }) =>
      this.bulkPayService.getRecipientsCategories(page, limit, search, startDate, endDate).pipe(
        map((response: any) => {
          const recipientCategories = response.data?.data || [];
          const pagination = response.data?.pagination || {};
          return bulkPayActions.fetchRecipientCategoriesSuccess({ recipientCategories, pagination });
        }),
        catchError((error: HttpErrorResponse) => {
          this.toastr.error(error.error?.message || 'An error occurred', 'Error');
          return of(bulkPayActions.fetchRecipientCategoriesFailed());
        })
      )
    )
  )
);
  
  
  
  
    createRecipientCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(bulkPayActions.createRecipientCategory),
      exhaustMap((action) =>
        this.bulkPayService
          .createRecipientsCategory(action.recipientCategoryDto)
          .pipe(
            exhaustMap((response: any) => [
                bulkPayActions.createRecipientCategorySuccess(response?.data),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(bulkPayActions.createRecipientCategoryFailed())
            }
            )
          )
      )
    )
  );

  fetchRecipients$ = createEffect(() =>
  this.actions$.pipe(
    ofType(bulkPayActions.fetchRecipients),
    exhaustMap((action) =>
      this.bulkPayService
        .getRecipients()
        .pipe(
          exhaustMap((response: any) => [
              bulkPayActions.fetchRecipientsSuccess({ recipients: response.data }),
          ]),
          catchError((error: HttpErrorResponse) => {
            if(error.status == 400){
              this.toastr.info( 'No Data');
              return of(bulkPayActions.fetchRecipientsSuccess({ recipients: [] }),)
            }else {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(bulkPayActions.fetchRecipientsFailed())
            }
          }
          )
        )
    )
  )
);

  fetchRecipientsByCategory$ = createEffect(() =>
  this.actions$.pipe(
    ofType(bulkPayActions.fetchRecipientsByCategory),
    exhaustMap((action) =>
      this.bulkPayService
        .getRecipientsByCategory(action.categoryId)
        .pipe(
          exhaustMap((response: any) => [
              bulkPayActions.fetchRecipientsByCategorySuccess({ recipients: response.data.data }),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(bulkPayActions.fetchRecipientsByCategoryFailed())
          }
          )
        )
    )
  )
);

validateXcelAccount$ = createEffect(() =>
this.actions$.pipe(
  ofType(bulkPayActions.validateXcelAccount),
  exhaustMap((action) =>
    this.miscService
      .validateXcelAccount(action.walletNumber, action.schemeCode)
      .pipe(
        exhaustMap((response: any) => [
            bulkPayActions.validateXcelAccountSuccess({ xcelAccount: response.data }),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(bulkPayActions.validateXcelAccountFailed())
        }
        )
      )
  )
)
);

createRecipient$ = createEffect(() =>
this.actions$.pipe(
  ofType(bulkPayActions.createRecipient),
  exhaustMap((action) =>
    this.bulkPayService
      .createRecipient(action.recipientDto)
      .pipe(
        exhaustMap((response: any) => [
            bulkPayActions.createRecipientSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(bulkPayActions.createRecipientFailed())
        }
        )
      )
  )
)
);


editRecipient$ = createEffect(() =>
this.actions$.pipe(
  ofType(bulkPayActions.editRecipient),
  exhaustMap((action) =>
    this.bulkPayService
      .editRecipient(action.recipientDto)
      .pipe(
        exhaustMap((response: any) => [
            bulkPayActions.editRecipientSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(bulkPayActions.editRecipientFailed())
        }
        )
      )
  )
)
);

deleteRecipient$ = createEffect(() =>
this.actions$.pipe(
  ofType(bulkPayActions.deleteRecipient),
  exhaustMap((action) =>
    this.bulkPayService
      .deleteRecipient(action.recipientId)
      .pipe(
        exhaustMap((response: any) => [
            bulkPayActions.deleteRecipientSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(bulkPayActions.deleteRecipientFailed())
        }
        )
      )
  )
)
);

fetchAccountBalance$ = createEffect(() =>
this.actions$.pipe(
  ofType(bulkPayActions.fetchAccountBalance),
  exhaustMap((action) =>
    this.miscService
      .performBalanceInquiry(action.accountIdentifier)
      .pipe(
        exhaustMap((response: any) => [
            bulkPayActions.fetchAccountBalanceSuccess({ balance: response.data }),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(bulkPayActions.fetchAccountBalanceFailed())
        }
        )
      )
  )
)
);


sendOTP$ = createEffect(() =>
this.actions$.pipe(
  ofType(bulkPayActions.sendOTP),
  exhaustMap((action) =>
    this.miscService
      .requestTransactionOTP(action.accountIdentifier)
      .pipe(
        exhaustMap((response: any) => [
            bulkPayActions.sendOTPSuccess({otpInfo: response.data}),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(bulkPayActions.sendOTPFailed())
        }
        )
      )
  )
)
);

updateTransactionStatus$ = createEffect(() =>
this.actions$.pipe(
  ofType(bulkPayActions.updateTransactionStatus),
  exhaustMap((action) =>
    this.bulkPayService
      .updateTransactionStatus(action.updateTransactionStatusDto, action.transactionId, action.paymentId, action.status)
      .pipe(
        exhaustMap((response: any) => [
            bulkPayActions.updateTransactionStatusSuccess(),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(bulkPayActions.updateTransactionStatusFailed())
        }
        )
      )
  )
)
);

fetchRecipientBanks$ = createEffect(() =>
  this.actions$.pipe(
    ofType(bulkPayActions.fetchRecipientBanks),
      exhaustMap((action) =>
      this.bulkPayService
      .getRecipientBanks(action.countryCode)
      .pipe(
        exhaustMap((response: any) => [
            bulkPayActions.fetchRecipientBanksSuccess({ banks: response.data }),
        ]),
        catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured, banks could not be fetched');
            return of(bulkPayActions.fetchRecipientBanksFailed())
        }
        )
      )
     )
    )
  );

  

}